import React, { useMemo } from "react";

import CustomSelect from "../components/CustomSelect";
import { UNITS } from "../constants";
import { DEFAULT_LOCALE_EN } from "../locale";
import { MonthsProps } from "../types";
import { classNames } from "../utils";

export default function Months(props: MonthsProps) {
  const {
    value,
    setValue,
    locale,
    className,
    humanizeLabels,
    disabled,
    readOnly,
    period,
    periodicityOnDoubleClick,
    mode
  } = props;
  const optionsList = locale.months || DEFAULT_LOCALE_EN.months;

  const internalClassName = useMemo(
    () =>
      classNames({
        "react-js-cron-field": true,
        "react-js-cron-months": true,
        [`${className}-field`]: !!className,
        [`${className}-months`]: !!className
      }),
    [className]
  );

  return (
    <div className={internalClassName}>
      {locale.prefixMonths !== "" && <span>{locale.prefixMonths || DEFAULT_LOCALE_EN.prefixMonths}</span>}

      <CustomSelect
        className={className}
        disabled={disabled}
        grid={false}
        humanizeLabels={humanizeLabels}
        locale={locale}
        mode={mode}
        optionsList={optionsList}
        period={period}
        periodicityOnDoubleClick={periodicityOnDoubleClick}
        placeholder={locale.emptyMonths || DEFAULT_LOCALE_EN.emptyMonths}
        readOnly={readOnly}
        setValue={setValue}
        unit={{
          ...UNITS[3],
          // Allow translation of alternative labels when using "humanizeLabels"
          // Issue #3
          alt: locale.altMonths || DEFAULT_LOCALE_EN.altMonths
        }}
        value={value}
      />
    </div>
  );
}
